(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-new"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('puzzle-product-helper')) {
  customElements.define('puzzle-product-helper', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-component');
      this.gallery = this.root?.querySelector('product-images');
      if (!this.gallery) return;
      this.frame = 0;
      this.schedule = () => {
        if (!this.frame && this.isConnected) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.refresh();
        });
      };
      this.onImageLoad = event => {
        if (event.target instanceof HTMLImageElement) this.schedule();
      };
      this.gallery.addEventListener('load', this.onImageLoad, true);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.gallery, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'data-active-media']});
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.gallery);
      this.gallery.querySelectorAll('.product__photo, .product__media').forEach(node => this.resizeObserver.observe(node, {box: 'border-box'}));
      customElements.whenDefined('product-images').then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    eligible(slide) {
      for (let node = slide; node && node !== this.gallery; node = node.parentElement) {
        if (node.hidden || getComputedStyle(node).display === 'none' || node.style.visibility === 'hidden') return false;
      }
      return true;
    }
    refresh() {
      if (!this.isConnected || !this.gallery) return;
      const slides = [...this.gallery.querySelectorAll('.product__slide[data-image-id]')];
      const allowed = slides.filter(slide => this.eligible(slide));
      if (!allowed.length) return;
      let active = allowed.find(slide => slide.classList.contains('media--active'));
      if (!active) {
        const requested = this.gallery.getAttribute('data-active-media');
        active = allowed.find(slide => slide.dataset.mediaId === requested) || allowed[0];
        if (typeof this.gallery.setActiveMedia === 'function') {
          this.gallery.setActiveMedia(active.dataset.mediaId);
        } else {
          slides.forEach(slide => {
            slide.classList.toggle('media--active', slide === active);
            slide.classList.toggle('media--hidden', slide !== active);
            slide.classList.remove('media--hiding');
          });
          this.gallery.setAttribute('data-active-media', active.dataset.mediaId);
        }
      }
      const img = active.querySelector('img');
      if (img) {
        if (img.loading !== 'eager') img.loading = 'eager';
        if (img.complete && img.naturalWidth > 0) {
          if (img.classList.contains('is-loading')) img.classList.remove('is-loading');
          const wrapper = img.closest('.image-wrapper');
          if (wrapper?.classList.contains('is-loading')) wrapper.classList.remove('is-loading');
        }
      }
      const height = active.offsetHeight;
      if (height > 0 && this.gallery.style.getPropertyValue('--height') !== `${height}px`) {
        this.gallery.style.setProperty('--height', `${height}px`);
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.gallery?.removeEventListener('load', this.onImageLoad, true);
    }
  });
}

if (!customElements.get('puzzle-purchase-controller')) {
  customElements.define('puzzle-purchase-controller', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-component');
      this.form = document.getElementById(this.dataset.formId);
      this.button = this.form?.querySelector('[data-add-to-cart]');
      this.idInput = this.root?.querySelector('[data-ppn-variant-id]');
      const json = this.root?.querySelector('[data-product-json]');
      if (!this.form || !this.button || !this.idInput || !json) return;
      try {
        this.variants = new Map(JSON.parse(json.textContent).variants.map(variant => [String(variant.id), variant]));
      } catch (_) {
        return;
      }
      this.pending = false;
      this.onClick = event => {
        const button = event.target.closest('button[data-add-to-cart], button[data-add-to-cart-bar]');
        if (button !== this.button && !button?.matches('[data-add-to-cart-bar]')) return;
        this.submit(event);
      };
      this.onSubmit = event => {
        if (event.target === this.form) this.submit(event);
      };
      this.onChange = event => {
        const input = event.target;
        if (input.name === 'id' && input.form === this.form && !input.closest('noscript')) {
          this.idInput.value = input.value;
        }
        queueMicrotask(() => { if (this.isConnected) this.sync(); });
      };
      this.onVariant = event => {
        if (event.target !== this.root || !event.detail || !('variant' in event.detail)) return;
        this.idInput.value = event.detail.variant?.id || '';
        this.sync();
      };
      this.onComplete = event => {
        if (event.detail?.button !== this.button) return;
        this.pending = false;
        this.sync();
      };
      this.root.addEventListener('click', this.onClick, true);
      this.root.addEventListener('submit', this.onSubmit, true);
      this.root.addEventListener('change', this.onChange, true);
      this.root.addEventListener('input', this.onChange, true);
      this.root.addEventListener('theme:variant:change', this.onVariant);
      document.addEventListener('theme:product:add', this.onComplete);
      document.addEventListener('theme:product:add-error', this.onComplete);
      this.timer = setInterval(() => {
        const variant = this.variants.get(String(this.idInput.value));
        const disabled = !variant?.available || this.pending;
        if (!document.hidden && (this.lastVariantId !== this.idInput.value || this.button.disabled !== disabled)) this.sync();
      }, 250);
      this.sync();
    }
    sync() {
      const variant = this.variants.get(String(this.idInput.value));
      const unavailable = !variant || !variant.available;
      this.lastVariantId = this.idInput.value;
      const buttons = [this.button, ...this.root.querySelectorAll('[data-add-to-cart-bar]')];
      buttons.forEach(button => {
        const disabled = unavailable || this.pending;
        if (button.disabled !== disabled) button.disabled = disabled;
        button.setAttribute('aria-disabled', String(disabled));
        button.classList.toggle('ppn-purchase-unavailable', unavailable);
        if (this.pending) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
      });
      const wrapper = this.button.closest('[data-form-wrapper]');
      wrapper?.classList.toggle('variant--soldout', Boolean(variant && !variant.available));
      wrapper?.classList.toggle('variant--unavailable', !variant);
      const label = this.button.querySelector('[data-add-to-cart-text]');
      if (unavailable) {
        const text = variant ? this.dataset.soldOut : this.dataset.unavailable;
        buttons.forEach(button => {
          const textNode = button.querySelector('[data-add-to-cart-text]');
          if (textNode && textNode.textContent !== text) textNode.textContent = text;
        });
        this.wasUnavailable = true;
      } else if (this.wasUnavailable) {
        const nativeForm = this.button.closest('product-form');
        if (typeof nativeForm?.updateAddToCartState === 'function') {
          nativeForm.updateAddToCartState({variant});
        } else if (label) {
          label.textContent = this.dataset.addLabel;
        }
        this.wasUnavailable = false;
      }
      if (this.pending) buttons.forEach(button => { button.disabled = true; });
      return variant;
    }
    submit(event) {
      const variant = this.sync();
      if (!variant?.available || this.pending) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!this.form.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.form.reportValidity();
        return;
      }
      const cart = document.querySelector('cart-items');
      if (!cart || typeof cart.cartAddEvent !== 'function') return;
      if (this.form.querySelector('input[type="file"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const duplicateIds = Array.from(this.form.elements).filter(input => input.name === 'id' && input !== this.idInput && !input.disabled);
      duplicateIds.forEach(input => { input.disabled = true; });
      const errors = this.form.querySelector('[data-cart-errors-container]');
      errors?.classList.remove('is-visible');
      this.pending = true;
      if (window.a11y) window.a11y.lastElement = this.button;
      try {
        document.dispatchEvent(new CustomEvent('theme:cart:add', {detail: {button: this.button}}));
      } finally {
        duplicateIds.forEach(input => { input.disabled = false; });
        this.sync();
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.root?.removeEventListener('click', this.onClick, true);
      this.root?.removeEventListener('submit', this.onSubmit, true);
      this.root?.removeEventListener('change', this.onChange, true);
      this.root?.removeEventListener('input', this.onChange, true);
      this.root?.removeEventListener('theme:variant:change', this.onVariant);
      document.removeEventListener('theme:product:add', this.onComplete);
      document.removeEventListener('theme:product:add-error', this.onComplete);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
